import { createSvgIcon } from '@mui/material'

export const Multi6Icon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    height='24px'
    viewBox='0 0 24 24'
    width='24px'
    fill='currentColor'
  >
    <path
      xmlns='http://www.w3.org/2000/svg'
      d='M13 15H15C15.55 15 16.0208 14.8042 16.4125 14.4125C16.8042 14.0208 17 13.55 17 13V11C17 10.45 16.8042 9.97917 16.4125 9.5875C16.0208 9.19583 15.55 9 15 9H13V7H16V5H13C12.45 5 11.9792 5.19583 11.5875 5.5875C11.1958 5.97917 11 6.45 11 7V13C11 13.55 11.1958 14.0208 11.5875 14.4125C11.9792 14.8042 12.45 15 13 15ZM13 11H15V13H13V11ZM8 18C7.45 18 6.97917 17.8042 6.5875 17.4125C6.19583 17.0208 6 16.55 6 16V4C6 3.45 6.19583 2.97917 6.5875 2.5875C6.97917 2.19583 7.45 2 8 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V16C22 16.55 21.8042 17.0208 21.4125 17.4125C21.0208 17.8042 20.55 18 20 18H8ZM8 16H20V4H8V16ZM4 22C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20V6H4V20H18V22H4Z'
      fill='currentColor'
    />
  </svg>,
  'Multi6Icon',
)
